import { XmMenuItem } from '@optek/xm-bootstrap';

export const METER_DATA: XmMenuItem = {
  position: 2,
  title: 'Meter Data',
  icon: 'icon-chart-areaspline',
  route: { url: '/meter-data/user' },
  subMenuItems: []
};

export const SEARCHUSERS: XmMenuItem = {
  position: 3,
  title: 'Users',
  icon: 'icon-account-search',
  route: { url: '/search/users' },
  subMenuItems: []
};

export const SEARCHWORKORDERS: XmMenuItem = {
  position: 4,
  title: 'Work Orders',
  icon: 'icon-clipboard-text-search',
  route: { url: '/search/work-orders' },
  subMenuItems: []
};

export const SEARCHMETERS: XmMenuItem = {
  position: 5,
  title: 'Meters',
  icon: 'icon-meter-search',
  route: { url: '/search/meters' },
  subMenuItems: []
};

export const HIERARCHY: XmMenuItem = {
  position: 6,
  title: 'Hierarchy',
  icon: 'icon-account-hierarchy',
  subMenuItems: [
    {
      position: 1,
      title: 'My Hierarchy',
      icon: '',
      route: { url: '/hierarchy-stats' },
      subMenuItems: []
    },
    {
      position: 2,
      title: 'Corporate',
      icon: '',
      route: { url: '/hierarchy-stats/corp' },
      subMenuItems: []
    }
  ]
};

export const TEAMS: XmMenuItem = {
  position: 7,
  title: 'My Teams',
  icon: 'icon-account-multiple',
  route: { url: '/manage-teams' },
  subMenuItems: []
};

export const SUPPORT: XmMenuItem = {
  position: 8,
  title: 'Support',
  icon: 'icon-truck',
  // @ts-ignore ALM-277061
  subMenuItems: [
    {
      position: 10,
      title: 'FCC Data Sheet',
      icon: '',
      route: {
        url: '/assets/documents/FCC_Datasheet.pdf',
        params: undefined,
        isExternal: true
      },
      subMenuItems: []
    }
  ]
};

export const TRAINING = {
  position: 1,
  title: 'Training',
  icon: '',
  route: {
    url: 'https://etwiki.sys.comcast.net/display/NFT/XM2+Training',
    params: null,
    isExternal: true
  },
  subMenuItems: []
};

export const RMA = {
  position: 2,
  title: 'RMA',
  icon: '',
  route: { url: '/rma' },
  subMenuItems: []
};

export const KNOWLEDGE_BASE = {
  position: 1,
  title: 'Knowledge Base',
  icon: '',
  route: {
    url: 'https://docs.syndication.comcast.net/home/xmeter-support',
    params: null,
    isExternal: true
  },
  subMenuItems: []
};


export const SWAGGER = {
  position: 4,
  title: 'Swagger',
  icon: '',
  route: {
    url: '/assets/html/swagger/index.html',
    params: null,
    isExternal: true
  },
  subMenuItems: []
};

export const RELEASE_NOTES = {
  position: 3,
  title: 'Release Notes',
  icon: '',
  route: {
    url: '/release-notes',
    params: null,
    isExternal: false
  },
  subMenuItems: []
};

export const BASEMENU: XmMenuItem[] = [
  METER_DATA,
  SEARCHUSERS,
  SEARCHWORKORDERS,
  SEARCHMETERS
];
